<script setup lang="ts">
import ApiDetailView from '@/components/Api/ApiDetailView.vue'
import { FullScreenLoader } from '@/components/LoadingSpinner'
import store from '@/store'
import { EApiActions } from '@/store/apiStore/ApiStateType'
import { EStoreModules } from '@/store/storeType'
import { defaultApiModel, type ApiModel } from '@/types/models/ApiModel'
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { EOrganizationsApisPerm } from '../../../../types/permissions/OrganizationsPermissionsEnum'
import apiApi from '../../../../services/api.service'
import TypographyWithPrefix from '../../../../components/Typography/TypographyWithPrefix.vue'
import ShowableTypography from '../../../../components/Typography/ShowableTypography.vue'

const route = useRoute()
const isLoading = computed(() => store.state.api.isLoading)
const apiId = ref((route.params.api_id ?? route.params.id).toString())
const submitted = ref(false)

const data = ref<Partial<ApiModel>>({ ...defaultApiModel })
const api_key = ref()

const getApi = () =>
    store
        .dispatch(`${EStoreModules.API}/${EApiActions.FETCH_API}`, apiId.value)
        .then(res => (data.value = res))

onMounted(() => {
    if (typeof apiId.value === 'string') getApi()
})

const updateApi = (value: Partial<ApiModel>) => (data.value = { ...value })

const save = () => {
    submitted.value = true
    if (!data.value.name) return
    store
        .dispatch(`${EStoreModules.API}/${EApiActions.UPDATE_API}`, {
            apiId: apiId.value,
            apiData: data.value
        })
        .then(() => (submitted.value = false))
}

const getApiKey = (show: boolean) =>
    show && !api_key.value
        ? apiApi.getApiKey(apiId.value).then(res => (api_key.value = res.api_key))
        : undefined
</script>

<template>
    <FullScreenLoader :isLoading="!!isLoading" />
    <ApiDetailView
        :data="data"
        :buttonLabel="$t('common.saveModifications')"
        :loading="!!isLoading"
        :editPermission="EOrganizationsApisPerm.ORGANIZATIONS_APIS_VIEW"
        @click="save"
        @update="updateApi">
        <TypographyWithPrefix :prefix="$t('api.model.apiKey')" class="full-width">
            <template #edit>
                <ShowableTypography :label="api_key" @click="getApiKey" />
            </template>
        </TypographyWithPrefix>
    </ApiDetailView>
</template>
